import Vue from 'vue'
import Vuex from 'vuex'
import store from '../common/store/store'

Vue.use(Vuex)

export default store({})
